/* eslint-disable no-trailing-spaces */
export default {
  main: {
    source: 99,
    terminalId: 1,
    site_id: 33,
    enableWinterMode: false,
    usePayTicketNewMethod: false,
    enableMpesaPayment: false,
    adminPrintableTicketsCount: 1000,
    restrictedModePrintableTicketsCount: 1000,
    amountToSwitchToCashMode: 10000000,
    hotjarId: null,
    useArrowsOnHomeSlider: false,
    fontName: "oswald",
    defaultRoute: '/thirdPartyGame/500022253',
    adminDefaultRestricted: false,
    minimumEarlyCashoutCount: 0,
    allowSportsAndVirtualsMix: true,
    hideIdColumnFromAdminPage: true,
    showCustomLockScreenMessages: false,
    enableTransferAmountFlow: false,
    showMediaSlidesDots: false,
    sportsIdsBlackList: [],
    fieldsToHide: {
      enablePlaceBet: true,
      enableTaxOnStakeField: true,
      enableTaxOnReturnField: true,
      enableError: true,
      enableTotalWinField: true,
    },
    enableTerminalUsageConfirmation: false,
    virtualSportsWithNewLabel: [],
    verificationInactiveTimeInSeconds: 30,
    resultPageVirtualsId: [150, 197, 118, 54, 55, 181],
    yandexMetricaId: null,
    depositWithoutLogin: {
      disabled: false,
    },
    isWithdrawal: false,
    unfocusForInactivity: true,
    isViewMode: false,
    hotjarSv: 6,
    defaultTheme: "dark",
    enableThemeToggle: false,
    isTicketsCheckable: false,
    enableMultiDepositMode: false, // config for oktpay deposit mode features
    enableClientDepositMode: false,
    oktoMerchantId: "",
    oktoTestTerminalIds: [],
    oktoTestMerchantId: '',
    disableBalanceMixing: false,
    enableTerminalBalancePolling: false,
    terminalBalancePollingInterval: 20,
    homeBannerSlides: [{ fileType: "jpeg", path: "/betting/prematch/all" }],
    homeFavoritCompetitions: [
      {
        id: 1,
        url: '/betting/prematch/all/Soccer/2570001/538',
        name: 'Football',
        classname: "layer",
      },
      {
        id: 2,
        url: '/betting/prematch/all/Basketball/50003/756',
        name: 'Basketball',
        classname: "layer",
      },
      {
        id: 3,
        url: '/betting/prematch/all/Tennis',
        name: 'Tennis',
        classname: "layer",
      },
    ],
    showResultsSection: false,
    inactivePopupDuration: 60,
    casinoIframeGameNames: [],
    alwaysShowCheckTicket: false,
    homeIdleTimeInMinutes: 0,
    enableCpfAutoFill: false,
    slug: 1,
    needAdminConfirmation: false,
    isNewStatistic: true,
    enableRegistration: false,
    enableMultipleTicketPay: false,
    needAdminForResetPin: false,
    showBetBuilderSection: false,
    ticketPayoutExpirationDays: 180,
    ticketScanExpirationDays: 100,
    title: "Terminal PRO",
    ticketAvailableViewMode: ["card"],
    registrationSteps: [{ name: "cpf_phone_number" }, { name: "pin" }],
    registartionCustomField: {
      phoneCode: '+374',
      placeHolder: '',
      phoneNumberLength: 10000,
    },
    enableTicketAutoCashoutAmountUpdate: false,
    enableTicketPopupFlow: true,
    enableReloadBySwipe: true,
    enableTicketTimer: false,
    disableCheckTicketAfterLogin: false,
    hasLogo: true,
    restrictedAdminPrintableTicketsCount: 5,
    restrictedCashoutPrintableTicketsCount: 100000,
    enabel18PlusIcon: false,
    useBetBookLastApi: false,
    hasDayFilter: false,
    enableHeaderAdminSection: false,
    terminalMode: "betting",
    useBookingV2Api: true,
    bigWinAmount: 9999999,
    enableDefaultHomeHeader: true,
    withdrawalRequest: {},
    homeMediaSlides: [
      {
        type: 'boosted',
        path: '/betting/prematch/all/boosted/all/all',
      },
      {
        type: 'multiple',
        path: '/betting/prematch/all/multiples',
      },
      {
        type: 'sport',
        path: '/betting/prematch/all',
      },
    ],
    staffPassword: '',
    websitePasswordHash: 'f22ea9722676fe7d586ef434a2c8a82978362ac6b000cf10850d73baf3f67f27',
    showPopularSection: true,
    googleAnalyticsId: 'UA-152567467-2',
    taxRange: [
      {
        range: [0, 66750],
        present: 1,
      },
      {
        range: [66750, 445000],
        present: 16,
      },
      {
        range: [445000, 100000000000000],
        present: 25,
      },
    ],
    disableRemoteConfig: true,
    isAdminSettingsButton: false,
    logoSize: 'small',
    termsAndConditions: false,
    enableTouchToClick: false,
    enableGameInfo: true,
    showEventTypeFilter: true,
    cashoutCommissionPercent: 4,
    cashoutPopupTimer: 60,
    showItfStatistics: true,
    authSessionLifeTime: 2628000,
    authSessionLessLifeTime: 1800,
    rfidPinCode: false,
    subscribeToCashdesk: true,
    showTicketAfterPay: 10000,
    testString: 'SwarmTestPrivateKey',
    popupForTerminalLock: false,
    mandatoryCasinoLogin: false,
    balanceLimit: 10000000000,
    useLoyalCardBarcode: false,
    enableLanguageSwitcher: true,
    clientTransactionSuccessStateDelay: 5,
    availableLanguages: {
      eng: {
        short: 'EN',
        name: 'Eng',
        order: 1,
      },
      spa: {
        short: 'ES',
        name: 'Esp',
        order: 2,
      },
      arm: {
        short: 'HY',
        name: 'Հայ',
        order: 4,
      },
      rus: {
        short: 'RU',
        name: 'Рус',
        order: 3,
      },
      por: {
        short: 'PT',
        name: 'Por',
        order: 5,
      },
      tur: {
        short: 'TR',
        name: 'Tür',
        order: 6,
      },
      kor: {
        short: 'KO',
        name: '한국어',
        order: 7,
      },
      jpn: {
        short: 'JP',
        name: '日本語',
        order: 8,
      },
      chi: {
        short: 'CH',
        name: '繁体中文',
        order: 9,
      },
      geo: {
        short: 'KA',
        name: 'ქართული',
        order: 10,
      },
      swe: {
        short: 'SE',
        name: 'Swe',
        order: 11,
      },
      ger: {
        short: 'DE',
        name: 'Deu',
        order: 12,
      },
      nor: {
        short: 'NO',
        name: 'Nor',
        order: 13,
      },
      fra: {
        short: 'FR',
        name: 'Fra',
        order: 14,
      },
      dut: {
        short: 'NL',
        name: 'Ned',
        order: 15,
      },
    },
    liveChat: null,
    enableFunctionalitySetMousePosition: true,
    disableTitoBet: false,
    enableKeyboardCatching: false,
    availableCurrencies: ['USD', 'EUR', 'RUB', 'UAH', 'CNY', 'KZT', 'PLN', 'SEK', 'MXN', 'KES', 'CIC'],
    currencyRounding: 2,
    loadUserCurrencyConfig: false,
    useLadderForFractionalFormat: true,
    roundDecimalCoefficients: 2,
    gamesAuthorizationUrl: '/authorization.php',
    termsAndConditionsDefaultLanguage: 'eng',
    personalDetails: {
      readOnlyFields: ['id', 'username', 'first_name', 'last_name', 'birth_date', 'gender', 'email', 'doc_number'],
      editableFields: ['country_code', 'city', 'phone', 'bank_info', 'password', 'address'],
      requiredFields: ['country_code', 'city', 'phone', 'password'],
      bankInfoMask: '99999999999',
    },
    video: {
      enableLiveGamesFilter: true,
      availableVideoProviderIds: [1, 3, 5, 16, 19],
      enabled: true,
      autoPlay: true,
      useHlsUrlFromResponse: false,
      evenIfNotLoggedIn: false,
    },
    casinoStartDateFormat: 'YYYY-MM-DT00:00:01',
    casinoEndDateFormat: 'YYYY-MM-DT23:59:59',
    dateFormat: 'dd/MM/yy',
    gameDateTimeFormat: 'HH:mm DD/MM/YY',
    dateTimeFormat: 'ddd, D MMM YYYY, HH:mm',
    shortDateTimeFormat: 'ddd HH:mm',
    prematchTimeFilterValues: [3, 6, 12, 24, 48, 72],
    regConfig: {
      settings: {
        minYearOld: 18,
        maxYearOld: 100,
        defaultCountry: null,
        loginAfterRegistration: true,
        sendEmailAsUsername: false,
        dateFormat: 'YYYY-MM-DD',
        restrictedCountries: [],
        disablePhoneValidation: false,
      },
    },
    payments: [],
    paymentByCurrency: false,
  },
  openLoginFormFromLockTerminal: true,
  perBetshopLanguages: [],
  registrationFormConfigs: {
    registrationFormSteps: [
      { name: 'personal_information' },
      { name: 'contact_information' },
      { name: 'credential_information' },
      { name: "registrationTermsAndConditions_information" },
    ],
    registrationFormFiledConfigs: {
      firstName: true,
      lastName: true,
      birthDate: true,
      country: true,
      userName: true,
      password: true,
      confirmPassword: true,
      email: true,
      phoneNumber: true,
      street: true,
      city: true,
      zipCode: true,
      rull18: true,
      termsAndConditions: true,
    },
    registrationUserName: 'userName',
  },
  defaultPopupPosition: 'center',
  verification: {
    enabled: false,
  },
  footer: {
    footerEnabled: false,
  },
  disableTicketsFlow: false,
  historyTabConfig: [
    {
      icon: 'sports-section',
      title: 'Sport',
    },
    {
      icon: 'casino-7',
      title: 'Casino',
    },
    {
      icon: 'terminal-deposit-success',
      title: 'Withdrawal',
    },
  ],
  wheelConfig: {
    enableWheel: false,
    isLoggedIn: false,
    spinRotationCount: 4,
    minSelectionsCount: 3,
    minSelectionOdd: 1.2,
    minOdd: 2.5,
    maxOdd: 10000000,
    maxStake: 10000000,
    minStake: 1,
    usageRules: {
      minStake: 0,
      minOdd: 1.5,
      maxOdd: 50,
      minSelections: 2,
      maxSelections: 8,
    },
    wheelBoosts: [
      {
        name: 'Profit Boost',
        value: 10,
      },
      {
        name: 'Profit Boost',
        value: 25,
      },
      {
        name: 'Profit Boost',
        value: 20,
      },
      {
        name: 'Profit Boost',
        value: 15,
      },
      {
        name: 'Profit Boost',
        value: 35,
      },
    ],
  },
  dailyReportUnitsToShow: ["bet", "wonBets", "paidWonBets", "deposit", "withdrawal"],
  enableClientTransactionWithoutAdmin: false,
  clientTransactionView: {
    enableClientWithdraw: true,
    clientTransactionRightSideResize: false,
  },
  enableAllSectionInLive: true,
  currencySymbol: {
    USD: "$",
    EUR: "€",
    TTD: "TT$",
    AMD: "Դ ",
    GEL: "₾",
    GBP: "£",
    BGN: 'лв',
    PEN: "S/",
    RUB: "₽",
    TRY: "₺",
    TZS: "TSh",
    BRL: "R$",
    COP: "$",
    CAD: "$",
    IDR: "Rp",
    NAD: "N$",
    AOA: "Kz",
    DOP: "RD$",
    KHR: "KHR",
    CFA: "CFA ",
    CLP: "CLP",
    TND: "TND ",
    RON: "RON ",
    MXN: "MXN ",
    PLN: "PLN ",
    SEK: "SEK ",
    ZAR: "ZAR ",
    TJS: "TJS",
    PHP: "PHP",
    GMD: "GMD",
    NGN: "NGN",
    KES: "KES",
    GYD: "GYD",
    CIC: "CIC"
  },
  betslipDisabledUrls: [
    "/",
    "/virtuals/results",
    '/casino-game/*',
    "/admin/*",
    "/casino/*",
    "/liveCasino/*",
    "/dealer",
    "/prematch/results",
    "/betting/prematch/all/multiples",
    "/betting/live/all/multiples",
    "/tickets",
    "/thirdPartyGame/*",
    "/bethistory",
    "/freebets",
    "/casino-provider/*",
    "/casino-category/*"
  ],
  homePagesUrl: [
    {
      id: 1,
      url: '/betting/live',
      icon: 'global-icon icon-circle icon-a',
      className: 'live-section',
      name: 'Live',
    },
    {
      id: 1992,
      url: '/betting/prematch',
      className: 'prematch-section',
      name: 'Sports',
    },
    {
      id: 3,
      url: '/betting/results',
      className: 'results-section',
      name: 'Results',
    },
  ],
  home: {
    grid: [
      ['shortpages', 'banner'],
      ['slider', 'banner'],
      ['comp', 'banner'],
    ],
    gridColumns: '3fr 1fr',
    gridRows: '5fr 24fr 10fr',
    liveGamesCount: 6,
    casinoGamesCount: 6,
    customClassName: "layer"
  },
  verticalHome: {
    grid: [["shortpages"], ["slider"], ["populargames"], ["casinogames"]],
    gridColumns: "1fr",
    gridRows: "1.5fr 7fr 6fr 4fr",
    topPagesPaths: ['/betting/live', '/betting/prematch', '/casino', '/betting/results'],
  },
  thirdParty: {
    goldenRaceStreamURL: "https://virtual-games.virtustec.com/launcher",
    goldenRaceStreamTempSportsMap: {
      11101: "GRSGlobalNations",
      13119: "GRSLeagueKenya",
      13132: "GRSLeaguePoland",
      13144: "GRSLeagueEthiopia",
      13169: "GRSLeagueAustria",
      13212: "GRSLeagueSuperEuro",
      13254: "GRSLeagueSuperEuroHighOdds",
      13258: "GRSLeagueEngland",
      13266: "GRSLeagueGermany",
      13272: "GRSLeagueFrance",
      14106: "GRSTournamentEuroCup2020",
      14203: "GRSTournamentChampionsRet",
      15100: "GRSKeno",
      15101: "GRSKenoDeluxe",
      15400: "HTVLKenoDeluxe",
      16100: "GRSSpin2Win",
      16101: "GRSSpin2WinRoyale",
      17100: "GRSPerfectSix",
      20100: "GRSDog6",
      21100: "GRSHorse",
      21202: "GRSHorses6V2",
      21203: "GRSHorse8V2",
      30400: "HTVLMega6",
      34400: "HTVLSpin2Wheels",
      "14214": "GRSTournamentWorldCup",
      14222: "GRSTournamentEuroCup",
      20101: "GRSDog6HighOdds",
      "21103": "GRSHorseHighOdds",
      "23100": "GRSSpeedway",
      "25100": "GRSMotorbikes",
      "41202": "GRSLeagueEngland",
      "41204": "GRSLeagueFrance",
      "41205": "GRSLeagueGermany",
      "41206": "GRSLeagueItaly",
      "41208": "GRSLeagueSpain",
      "41210": "GRSTournamentChampions",
      "41225": "GRSLeagueKenya",
      "50407": "SPFireCrash"
    },
  },
  virtualGames: {
    enabled: true,
    videoInUpperscreen: true,
    providers: {
      Betconstruct: {
        name: 'Betconstruct',
        id: 15,
      },
    },
  },
  settingsSection: {
    enabled: true,
    sections: ['adminAccess', 'oddsType', 'language', 'systemView'],
  },
  userSection: {
    sections: ['changePassword', 'betHistory', 'changePin'],
  },
  odd: {
    useLadderForFractionalFormat: true,
    roundDecimalCoefficients: 2,
    oddsFormat: 'decimal',
  },
  barcodeInputMaxLength: 21,
  betslip: {
    enableExpressCounterOffer: false,
    enableCounterOffer: false,
    enableBookingBet: false,
    enableExpressBonus: true,
    hidePlaceBetIfNotAuthorized: false,
    hideBookingBetAfterLogin: false,
    disableCounterOfferOnLive: false,
    taxPercentOnStake: 0,
    maxSelectionsCount: 30,
    enableBookingId: true,
    betDetailsOrder: [
      'total_odd',
      'stake_without_tax',
      'total_stake',
      'tax_on_stake',
      'min_possible_win',
      'possible_win',
      'bonus',
      'profit_boost',
      'tax_on_return_or_profit',
      'total_win',
    ],
    taxRange: [
      {
        percent: 0,
        entire_amount: false,
        from: 0,
        type: 2,
        to: 9007199254740991,
      },
    ],
  },
  terminal: {
    scrollButtons: false,
    printUserBet: true,
    scrollButtonsSearchAndPrintTickets: true,
    enableSignOutWithRfidButton: true,
    disableTicket: true,
    showMinPossibleWin: true,
    scrollButtonsSearchAndPrintLotteryTickets: true,
    enableAgeRestriction: true,
  },
  upper_screen: {
    statistics_live: true,
    statistics_prematch: true,
    live_streaming: true,
    live_animations: true,
  },
  liveCasinoActiveGroup: {
    'Live Roulette': 1,
    'Live BlackJack': 2,
    'Live Baccarat': 3,
    'Live Poker': 4,
  },
  urlPrefix: "https://games.betconstruct.com/authorization.php?",
  betBuilder: {
    brandName: "default",
    url: "https://betconstruct-prod-gen2.sportcastlive.com/markets",
    licenseKey: "a6aa080b-cea9-4e3f-aa02-9fef8d1f0c8f",
    password: "ewmFb896vwmHeRFp",
    enableTaxOnStake: true,
    oddsMap: {
      decimal: 'DecimalPrice',
      american: 'AmericanPrice',
      fractional: 'FractionalPrice',
      hongkong: 'HongKongPrice',
      indo: 'IndoPrice',
      malay: 'MalayPrice',
    },
    languageMap: {
      eng: 'en-GB',
      spa: 'es-ES',
      arm: 'hy-AM',
      rus: 'ru-RU',
      por: 'pt-PT',
      tur: 'tr-TR',
      lat: 'lv-LV',
      est: 'et-EE',
      rum: 'ro-RO',
      bgr: 'bg-BG',
    },
  },
  partner: {},
  rfid: {
    logoutIfIdleSecondsCount: 60 * 60,
  },
  enableDepositMoney: true,
  swarm: {
    debugging: false,
    languageMap: {
      pol: 'eng',
      por: 'por_2',
      'pt-br': 'por',
      fre: 'fra',
      chi: 'zho',
      mac: 'mkd',
      bgr: 'bgr',
      lat: 'lav',
      fas: 'far',
      rum: 'ron',
      hrv: 'srp',
      dut: 'nl',
    },
    sendSourceInRequestSession: true,
    sendTerminalIdlInRequestSession: false,
    webSocketTimeout: 5000,
    longpollUrl: 'https://eu-swarm-lp.betconstruct.com/',
    websocket: [
      {
        url: 'wss://mrg-swarm-betshops-ws.betconstruct.com/',
        // url: "wss://swarm-staging.betconstruct.com"
      },
    ],
    url: [
      {
        url: 'https://eu-swarm-betshops-lp.betconstruct.com',
      },
    ],
    useSecureHash: true,
    useWebSocket: true,
    maxWebSocketRetries: 100,
    webSocketRetryInterval: 2000,
  },
  casino: {
    defaultFilteredProvider: [],
    enabledProvidersList: [],
    gameOpenFullscreen: 'manual',
    enableMultipleProviderSelect: false,
    urlPrefix: false,
    url: 'https://www.cmsbetconstruct.com/casino',
    middlewareUrl: 'https://betshop-rgs-api.betcoapps.com',
    middlewareAuthToken: 'A4d822sU4R47E0z4XCf57OkFJbfiaZbW',
    enableCopyBet: false,
    games: {
      loaderStep: 30,
      lastPlayedLimit: 15,
    },
  },
  tournaments: {
    firstLoadStep: 10,
    loaderStep: 2,
    filtersData: [
      {
        name: 'Statuses',
        field: 'state',
        filters: [
          {
            name: 'Upcoming',
            value: 3,
            active: true,
          },
          {
            name: 'Live',
            value: 2,
            active: true,
          },
          {
            name: 'Finished',
            value: 1,
          },
          {
            name: 'Canceled',
            value: -1,
          },
        ],
      },
      {
        name: 'Registration statuses',
        field: 'registrationStatus',
        filters: [
          {
            name: 'Registration Started',
            value: 1,
            active: true,
          },
          {
            name: 'Registration Finished',
            value: 2,
          },
        ],
      },
      {
        name: 'Entry types',
        field: 'buyInStatus',
        filters: [
          {
            name: 'Buy-in',
            value: 1,
          },
          {
            name: 'Free Entry',
            value: 2,
            active: true,
          },
        ],
      },
    ],
  },
  liveCasino: {
    liveCasinoBlockedProviders: [],
    helpUrl: 'https://websitelivegames-am.betconstruct.com/Home/HelpInfo',
    clv: false,
    drg: false,
    games: {
      loaderStep: 21,
    },
  },
  env: {
    lang: 'eng',
  },
  adminWideLotteryPopups: true,
  adminPageButtons: [
    {
      name: 'Admin User',
      type: 'adminUserSections',
      hideOnRestrictMode: false,
      enabled: false,
    },
    {
      name: 'Application and terminal management',
      type: 'applicationAndTerminal',
      enabled: true,
    },
    {
      name: 'Tickets',
      type: 'lastTicket',
      enabled: true,
    },
    {
      name: 'Financial tracking',
      type: 'financialTracking',
      enabled: true,
      hideOnRestrictMode: false,
    },
    {
      name: 'Open last log file',
      type: 'openLastLogFile',
      enabled: true,
      hideOnRestrictMode: true,
    },
    {
      name: 'Lock',
      type: 'lockAndUnlock',
      param: {
        type: 'lock',
      },
      enabled: true,
    },
    {
      name: 'Unlock',
      type: 'lockAndUnlock',
      param: {
        type: 'unlock',
      },
      enabled: true,
    },
    {
      name: 'Devices',
      type: 'devices',
      enabled: true,
      hideOnRestrictMode: true,
    },
  ],
  applicationAndTerminalButtons: [
    {
      name: 'Shut down terminal',
      hideOnRestrictMode: true,
    },
    {
      name: 'Close application',
      hideOnRestrictMode: true,
    },
    {
      name: 'Reboot PC',
      hideOnRestrictMode: false,
    },
  ],
  lotteryTicketsCountOnRestrictedMode: 5,
  deviceManagementButtons: ['Reset bill acceptor', 'Reset Device Connections', 'Status'],
  // financialButtons: ["Last entered bills and coins", "Stacker balance", "Todays Report", "Encashment"],
  financialButtons: [
    {
      type: 'balance',
      name: 'Balance history',
    },
    {
      type: 'dailyReport',
      name: 'Daily Report',
    },
    {
      type: 'lastBills',
      name: 'Bills and coins',
    },
    {
      type: 'encashment',
      name: 'Encashment',
    },
  ],
  financialBalanceButtons: [
    {
      type: 'currentBalance',
      name: 'current balance',
    },
    {
      type: 'stackerBalance',
      name: 'Stacker balance',
    },
  ],
  lastTicketButtons: [
    {
      name: 'Bet tickets',
      type: 'betTicket',
      hideOnRestrictMode: false,
    },
    {
      name: 'Cash-out',
      type: 'cashoutTicket',
      hideOnRestrictMode: false,
    },
  ],
  textsPopupAfterActions: {
    Cashout: 'Thanks for your participation! Redeem your balance , please visit cashier.',
    CashoutBet: 'Thanks for your participation! Redeem your balance , please visit cashier.',
    EarlyCashoutSucceed: 'Your bet has been Cashed Out successfully!',
  },
  messages: {
    disableMessages: true,
  },
  gameDateFilter: [
    {
      name: 'Today',
      type: 'today',
    },
    {
      name: 'Tomorrow',
      type: 'tomorrow',
    },
    {
      name: 'This Week',
      type: 'thisWeek',
      default: true,
    },
  ],
  enableTimeFilterInPrintTicket: false,
  defaultTerminalParams: {
    pid: 33,
    tid: 992,
    token: 'bnBzAA==',
    currency: 'AMD',
  },
  useCurrencySymbol: true,
  staticStake: true,
  enableSportBanner: false,
  staticStakeCounts: {
    default: [5, 10, 20, 50, 100],
  },
  statisticParams: {
    URL: 'https://stats.feedconstruct.com/terminal/langId=${langId}/pwd=${pwd}/key=93f428d0-6591-48da-859d-b6c326db2448/matchId=${matchId}/',
    pwd: '176',
  },
  enableTouchPositionIniFrames: true,
  ticketBasedGameIds: ['112001', '112002', '112004', '112005', '112007', '156147', '112008', '400002', '500022253'],
  oldTicketsRestriction: false,
  enableMultipleTickets: true,
  minWinAmountForIdentification: 30,
  enableWinIdentification: false,
  enableLogoOnPopups: false,
  nextRacingEnabled: false,
  estimatedReturnAndTotalWinCalculationChange: true,
  enableCurrencyView: true,
  splitScreen: true,
  splitScreenUrl: 'https://bettingterminalupperscreen.betcoapps.com/',
  betNeedConfirmation: false,
  enableMultipleWinsPopup: true,
  multipleWinsMaxTicketsCount: 15,
  refreshButtonDisabledTime: 5000,
  showBalanceWithoutLogin: true,
  disableBalanceInHeader: false,
  disableCashoutInHeader: false,
  disableCashoutAfterLogin: true,
  disableDepositAfterLogin: true,
  enablePartialCashout: false,
  enableKeypressCashout: false,
  disableDepositInHeader: true,
  cashoutMethods: [],
  depositMethods: [],
  signInType: '',
  disablePlaceBetButton: false,
  repeatBetInterval: null,
  enableRepeatBetButton: true,
  enablePeriodScore: true,
  popupForTerminalInactivity: true,
  enableMarketCountInBetSlip: true,
  ticketPopupRemoveCounterSeconds: 10,
  AdminShortcutWithLoginOnly: false,
  superBetCountdownTime: 150,
  colorForTimer: '#cbe100',
  openSectionNameOnClick: false,
  showPopupAfterActions: true,
  enableLiveClock: true,
  enableTopGames: false,
  turnOffMaxBetButton: true,
  setOnlyBetcoGames: true,
  enableDraggable: true,
  rulesURL: 'https://btpro-bet-one.betconstruct.com.com/rulesContent/Regulament-pariuri.pdf',
  casinoGames: [],
  routes: [
    {
      name: 'Betting',
      url: 'prematch',
      type: 'sportsBook',
      enabled: true,
      nestedItems: [
        {
          url: 'live',
          name: 'Live',
          enabled: true,
          icon: 'circle',
        },
        {
          url: 'prematch',
          name: 'Sports',
          enabled: true,
          icon: 'casino-categories-Sportsbook',
        },
        {
          url: 'betBuilder',
          name: 'Bet Builder',
          enabled: true,
          icon: 'bet-builder',
        },
        {
          url: 'outrights',
          name: 'Outrights',
          enabled: true,
          icon: '',
        },
        {
          url: 'popular',
          name: 'Popular',
          enabled: true,
          icon: 'casino-categories-PopularGames',
        },
        {
          url: 'prematch/results',
          name: 'Results',
          enabled: true,
          icon: '',
        },
        {
          url: 'racings',
          name: 'Racing',
          enabled: true,
          icon: '',
        },
        {
          urlType: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: true,
          icon: 'flash',
        },
        {
          url: 'virtuals',
          name: 'Virtuals',
          enabled: true,
          icon: 'casino-categories-VirtualBetting',
        },
        {
          urlType: 'multiplesOfTheDay',
          name: 'Multiples of the day',
          enabled: false,
          icon: 'flash',
        },
        {
          urlType: 'boostedOdds',
          name: 'Boosted Odds',
          enabled: true,
          icon: 'boosted-odd',
        },
        {
          urlType: 'today',
          name: 'Today',
          enabled: true,
          icon: 'boosted-odd',
        },
      ],
    },
    {
      name: 'Casino',
      url: 'casino',
      type: 'casino',
      enabled: true,
      nestedItems: [
        {
          name: 'Casino',
          url: 'casino',
          enabled: true,
          icon: 'casino-7',
        },
        {
          name: 'Live Casino',
          url: 'liveCasino',
          enabled: true,
          icon: 'casino-categories-LotteryGames',
        },
      ],
    },
    {
      name: 'Virtual Games',
      url: 'thirdPartyGame/400002',
      type: 'virtualGames',
      enabled: true,
      nestedItems: [
        {
          url: 'thirdPartyGame/156147',
          name: 'Pascal Gaming',
          enabled: true,
          iframeFullscreen: false,
          gameId: '156147',
          icon: 'casino-categories-PGgames',
          gameWithSecondScreen: false,
          onlyInHeader: false,
        },
        {
          url: 'thirdPartyGame/400002',
          name: 'Golden Race',
          iframeFullscreen: false,
          enabled: true,
          icon: 'golden-race',
          gameId: '400002',
          gameWithSecondScreen: false,
          onlyInHeader: true,
        },
        {
          url: 'thirdPartyGame/10412176',
          name: 'Pool Masters',
          enabled: true,
          icon: 'win-cup',
          iframeFullscreen: false,
          gameId: '10412176',
          gameWithSecondScreen: false,
          hasNewLabel: true,
        },
      ],
    },
  ],
  availableOdds: [
    {
      odds: 'american',
      title: 'American',
      enabled: true,
    },
    {
      odds: 'decimal',
      title: 'Decimal',
      enabled: true,
    },
    {
      odds: 'malay',
      title: 'Malaya',
      enabled: true,
    },
    {
      odds: 'indo',
      title: 'indo',
      enabled: true,
    },
    {
      odds: 'hongkong',
      title: 'hongkong',
      enabled: true,
    },
    {
      odds: 'fractional',
      title: 'Fractional',
      enabled: true,
    },
  ],

  sportsbook: {
    liveNavigationOrder: ['allMatches', 'popular', 'betBuilder', 'outrights', 'results'],
    navigationOrder: ['allMatches', 'popular', 'betBuilder', 'outrights', 'results'],
    enablePeriodScore: true,
    usePartnerStreams: true,
    enableBannerAnimation: false,
    enableBetBuilderIcon: true,
    enableGameInfo: true,
    enableEventSideNameReplacement: false,
    marketGroupSelectHighlightedMode: false,
    enableMarketSearch: true,
    timeFormat: 'HH:mm',
    enableStatisticsIcon: true,
    enableVirtualStreams: true,
    enableBoostedOdds: true,
    enablePredefinedMultiples: true,
    virtualsSportIdsBlackList: [],
    timeFilter: {
      prematchDateFilter: [
        {
          label: '3 HRS',
          value: 3,
          type: 'hours',
        },
        {
          label: '6 HRS',
          value: 6,
          type: 'hours',
        },
        {
          label: '12 HRS',
          value: 12,
          type: 'hours',
        },
        {
          label: 'Today',
          value: 'today',
          type: 'today',
        },
        {
          label: 'Days',
          value: 6,
          type: 'days',
        },
        {
          label: 'Month',
          value: 2,
          type: 'months',
        },
        {
          label: 'All',
          value: 'all',
          type: 'all',
        },
      ],
    },
    possibleBoostedSportList: [
      'Soccer',
      'Tennis',
      'Basketball',
      'Handball',
      'IceHockey',
      'Snooker',
      'Volleyball',
      'Baseball',
      'Boxing',
      'Mma',
      'Darts',
      'AmericanFootball',
      'Futsal',
      'RugbyUnion',
      'Politics',
      'Formula1',
      'Motorbikes',
    ],
    sportList: {
      enableScroll: false,
      closeAfterSelect: true,
      enableLiveAll: true,
    },
    competitionList: {
      closeAfterSelect: true,
      showTopCompetitionsListFixed: false,
    },
    asianViewMarket: {
      Soccer: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              side: ["1X", "12", "X2"],
            },
            {
              display_key: "NEXTGOALTOSCORE",
              title: "NEXT GOAL TO SCORE",
              side: ["Home", "No", "Away"],
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
            {
              display_key: "ODD/EVEN",
              market_type: {
                "@in": ["EvenOddTotal", "FirstHalfEvenOddTotal", "SecondHalfEvenOddTotal"],
              },
              title: "Total Goals: Even/Odd",
              side: ["Even", "Odd"],
            },
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "DOUBLE CHANCE",
              market_type: {
                "@in": ["DoubleChance", "HalfTimeDoubleChance", "SecondHalfDoubleChance",],
              },
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals",
              side: ["Over", "Under"],
              alt_main_order: 1,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 1.5",
              side: ["Over", "Under"],
              base: 1.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 2.5",
              side: ["Over", "Under"],
              base: 2.5,
            },
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["OverUnder", "HalfTimeOverUnder", "2ndHalfTotalOver/Under"],
              },
              title: "Total Goals 3.5",
              side: ["Over", "Under"],
              base: 3.5,
            },
          ],
          [
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both team to score",
              side: ["Yes", "No"],
            },
            {
              display_key: "DRAWNOBET",
              title: "DRAW NO BET",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              market_type: {
                "@in": ["AsianHandicap", "HalfTimeAsianHandicap", "2ndHalfAsianHandicap"],
              },
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "CARDSTOTALS",
              title: "Yellow Cards: Total",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      CyberFootball: {
        prematch: [
          [{
            display_key: "WINNER",
            title: "Winner",
            side: ["P1", "X", "P2"],
          }],
        ],
        live: [
          [{
            display_key: "WINNER",
            title: "Winner",
            side: ["P1", "X", "P2"],
          }],
        ],
      },
      Tennis: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "SetHandicap",
              title: "Set Games Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "SET TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "Handicap",
              title: "Games Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: {
                "@in": ["SetOverUnder", "TotalGamesOver/Under"],
              },
              title: "TOTAL GAMES",
              side: ["Over", "Under"],
            },
            {
              market_type: {
                "@in": ["TotalGamesOddorEven", "SetTotalGamesOddEven"],
              },
              title: "TOTAL GAMES ODD OR EVEN",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      Basketball: {
        live: [
          [
            {
              title: "Overtime",
              market_type: "Overtime",
              side: ["Yes", "No"],
            },
            {
              display_key: "HANDICAP",
              title: "Points Handicap",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
        prematch: [
          [
            {
              market_type: "MatchWinner2",
              // display_key: "WINNER",
              title: "Match Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Match Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              title: "Match Total",
              side: ["Over", "Under"],
            },
            {
              display_key: "ODD/EVEN",
              title: "Match Total Odd/Even",
              side: ["Even", "Odd"],
            },
          ],
        ],
      },
      IceHockey: {
        live: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Match Winner (Including Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both Teams To Score (Regular Time)",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                '@in': ['MatchTotal2', 'PeriodTotal2'],
              },
              display_key: 'TOTALS',
              title: 'Total (Regular Time)',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              market_type: "MatchWinner3",
              title: "Match Result (Regular Time)",
              side: ["P1", "X", "P2"],
            },
            {
              display_key: "DOUBLE CHANCE",
              title: "Double chance (Regular Time)",
              side: ["1X", "12", "X2"],
            },
          ],
          [
            {
              display_key: "WINNER",
              title: "Match Winner (Including Overtime)",
              market_type: "MatchWinner2",
              side: ["P1", "P2"],
            },
            {
              display_key: "BOTHTEAMTOSCORE",
              title: "Both Teams To Score (Regular Time)",
              side: ["Yes", "No"],
            },
            {
              market_type: {
                '@in': ['MatchTotal2', 'PeriodTotal2'],
              },
              display_key: 'TOTALS',
              title: 'Total (Regular Time)',
              side: ['Over', 'Under'],
            },
            {
              market_type: {
                '@in': ['MatchHandicap2', 'PeriodHandicap2'],
              },
              display_key: 'HANDICAP',
              title: 'Handicap (Regular Time)',
              side: ['Home', 'Away'],
            },
          ],
        ],
      },
      Volleyball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              market_type: "HANDICAP",
              title: "Match points Handicap",
              side: ["Home", "Away"],
            },
            {
              market_type: "TOTALS",
              title: "Total Points",
              side: ["Home", "Away"],
            },
          ],
          [
            {
              market_type: {
                "@in": ["MatchHandicap2", "PeriodHandicap2"],
              },
              display_key: "HANDICAP",
              title: "Handicap (Regular Time)",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
            {
              display_key: "HANDICAP",
              // market_type: "MatchTotalPointsHandicap",
              title: "Points Handicap",
              side: ["Home", "Away"],
            },
            {
              display_key: "TOTALS",
              // market_type: "MatchTotalPointsOverUnder",
              title: "Total points",
              side: ["Over", "Under"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
              market_type: "TotalbySets",
            },
          ],
        ],
      },
      Mma: {
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              title: "Fight to Go the Distance",
              side: ["Yes", "No"],
              market_type: 'FighttoGotheDistance'
            },
          ],
        ]
      },
      Pesapallo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Handball: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
      },
      BallHockey: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Futsal: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyLeague: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      RugbyUnion: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "Total Goals",
              side: ["Over", "Under"],
            },
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
              alt_main_order: 1,
            },
            {
              display_key: "WINNER",
              title: "Match Result",
              side: ["P1", "P2"],
            },
          ],
        ],
      },
      WaterPolo: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "HANDICAP",
              title: "Handicap",
              side: ["Home", "Away"],
            },
          ],
        ],
      },
      Darts: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              market_type: "TotalSetsOver/Under",
              title: "TOTAL SETS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      Chess: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "X", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
      default: {
        live: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
        prematch: [
          [
            {
              display_key: "WINNER",
              title: "Winner",
              side: ["P1", "P2"],
            },
          ],
          [
            {
              display_key: "TOTALS",
              title: "TOTALS",
              side: ["Over", "Under"],
            },
          ],
        ],
      },
    },
  },
};
